var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Footer',{staticClass:"ftr"},[_c('div',{staticClass:"copyright"},[_c('h6',[_vm._v("© 2018 Precision Medicine Group, Inc. All rights reserved")]),_c('div',{ref:"buttona",attrs:{"id":"buttona"}},[_vm._v(_vm._s(this.$store.state.logUser))])]),(this.$store.state.isLogged)?_c('h6',[_vm._v(" PICOS CRITERIA ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }